import { useEffect, useState } from "react";

const navItems = [
  { label: "首页", href: "#home" },
  { label: "视频资源", href: "#videos" },
  { label: "写真合集", href: "#photobooks" },
  { label: "图片专题", href: "#gallery" },
  { label: "资源分类", href: "#categories" },
  { label: "最新收录", href: "#updates" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="flex items-center justify-between h-16 px-4 md:px-8">
        <a href="#home" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-play-circle-fill text-xl"></i>
          </span>
          <span className="font-heading text-xl font-bold text-foreground-950 tracking-wide">
            色虎
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#gallery"
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-compass-3-line"></i>
            开始浏览
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-b border-background-200 px-4 py-3">
          <div className="grid grid-cols-2 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 text-sm rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}